export const comments_5480355 = {"data":{"data":[],"links":{}}}